export const flightReport = [
  'created',
  'element',
  'rfid_serial',
  'air_guide',
  'client_status',
  'withdrawal_request_datetime',
  'delta_withdrawal_request',
  'withdrawal_request_status',
];

export const flightReportTableColumns = [
  {
    field: 'created',
    header: 'Fecha asociación',
    sortable: true,
    pipe: false,
    filterField: 'created',
    filterOptions: [],
    labelFilter: 'Seleccionar',
  },
  {
    field: 'element',
    header: 'Elemento',
    sortable: true,
    pipe: false,
    filterField: 'element',
    filterOptions: [],
    labelFilter: 'Seleccionar',
  },
  {
    field: 'rfid_serial',
    header: 'Serie RFID',
    sortable: true,
    pipe: false,
    filterField: 'rfid_serial',
    filterOptions: [],
    labelFilter: 'Seleccionar',
  },
  {
    field: 'air_guide',
    header: 'Guia Aerea',
    sortable: true,
    pipe: false,
    filterField: 'air_guide',
    filterOptions: [],
    labelFilter: 'Seleccionar',
  },
  {
    field: 'client_status',
    header: 'Estado FastAir Export',
    sortable: true,
    pipe: false,
    filterField: 'client_status',
    filterOptions: [],
    labelFilter: 'Seleccionar',
  },
  {
    field: 'withdrawal_request_datetime',
    header: 'Hora Solicitud de Retiro',
    filterField: 'withdrawal_request_datetime',
    sortable: true,
    pipe: true,
    labelFilter: 'Seleccionar',
  },
  {
    field: 'delta_withdrawal_request',
    header: 'Tiempo Demora',
    filterField: 'delta_withdrawal_request',
    sortable: true,
    pipe: false,
    labelFilter: 'Seleccionar',
  },
  {
    field: 'withdrawal_request_status',
    header: 'Estado',
    filterField: 'withdrawal_request_status',
    sortable: true,
    pipe: true,
    labelFilter: 'Seleccionar',
  },
];
